if (!customElements.get('recipient-form')) {
  customElements.define('recipient-form', class extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector('[type="checkbox"]');
      this.fields = [...this.querySelectorAll('.recipient-fields input, .recipient-fields textarea')];
      this.email = this.querySelector('[type="email"]');
      this.control = this.querySelector('[id^="Recipient-Control-"]');
      this.offset = this.querySelector('[id^="Recipient-Offset-"]');
      this.date = this.querySelector('[type="date"]');
      this.error = this.querySelector('.recipient-form__error');
      this.form = this.closest('form');
      this.onChange = () => this.update();
      this.onSuccess = () => { this.checkbox.checked = false; this.fields.forEach(field => { field.value = ''; }); this.update(); };
      this.onError = event => {
        const description = event.detail?.response?.description;
        if (!description || typeof description !== 'object') return;
        this.error.textContent = Object.values(description).flat().filter(value => typeof value === 'string').join(' ');
        this.error.hidden = !this.error.textContent;
        const generic = this.closest('product-form')?.querySelector('[data-cart-errors-container]');
        if (generic && this.error.textContent) generic.classList.remove('is-visible');
      };
      this.checkbox.addEventListener('change', this.onChange);
      this.form?.addEventListener('theme:product:add', this.onSuccess);
      this.form?.addEventListener('theme:product:add-error', this.onError);
      this.control.disabled = true;
      this.update();
    }
    update() {
      const enabled = this.checkbox.checked;
      this.fields.forEach(field => { field.disabled = !enabled; });
      this.email.required = enabled;
      this.offset.disabled = !enabled;
      this.offset.value = String(new Date().getTimezoneOffset());
      const today = new Date();
      const end = new Date(today);
      end.setDate(end.getDate() + 90);
      const format = date => [date.getFullYear(), String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0')].join('-');
      this.date.min = format(today);
      this.date.max = format(end);
      this.error.hidden = true;
      this.error.textContent = '';
    }
    disconnectedCallback() {
      this.checkbox?.removeEventListener('change', this.onChange);
      this.form?.removeEventListener('theme:product:add', this.onSuccess);
      this.form?.removeEventListener('theme:product:add-error', this.onError);
    }
  });
}
